<div class="splash-screen app-secondary-green-theme" *ngIf="show" @fadeOut>
    <div class="" fxLayoutAlign="center center"  fxLayout="column" fxFlex>
        <div fxLayoutAlign="center center" fxLayout="column">
            <mat-spinner></mat-spinner>
        </div>
        <div class="logo-container">
            <img src="/assets/logo/abcis-white-logo.png" height="100px">
            <img src="/assets/logo/csa-logo.png" height="100px">
        </div>

    </div>
</div>